export const BoostLock = {
  minDaysDuration: 91,
  maxDaysDuration: 365 * 4,
  predefinedDaysDurations: [91, 365, 365 * 4],
};
